import axios from 'axios';
import { RoleEnumValue } from 'enums/RoleEnum';
import {
  ACTIVATE_ACCOUNT_PENDING,
  ACTIVATE_ACCOUNT,
  ACTIVATE_ACCOUNT_ERROR,
  LOGIN_FULFILLED,
  LOGIN_PENDING,
  LOGIN_REJECTED,
  LOGOUT,
  GET_PROFILE_PENDING,
  GET_PROFILE_FULFILLED,
  PERSISTED_EMAIL_CONFIRMATION,
  PERSISTED_EMAIL_CONFIRMATION_REJECTED,
  PERSISTED_PASSWORD,
  PERSISTED_PASSWORDRESET,
  PERSISTED_PASSWORDRESET_REJECTED,
  PERSISTED_PROFILE,
  PERSISTED_REGISTERVIEWMODEL,
  PERSISTING_EMAIL_CONFIRMATION,
  PERSISTING_PASSWORD,
  PERSISTING_PASSWORDRESET,
  PERSISTING_PROFILE,
  PERSISTING_REGISTERVIEWMODEL,
  PERSIST_PASSWORD_REJECTED,
  PERSIST_REGISTERVIEWMODEL_REJECTED,
  SENDING_EMAIL_CONFIRMATION_EMAIL,
  SENDING_PASSWORD_RECOVERY,
  SENT_EMAIL_CONFIRMATION_EMAIL,
  SENT_EMAIL_CONFIRMATION_REJECTED,
  SENT_PASSWORD_RECOVERY,
  SENT_PASSWORD_RECOVERY_REJECTED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_RECOVERY,
  UPDATE_PASSWORD_RESET,
  UPDATE_PROFILE,
  UPDATE_REGISTERVIEWMODEL,
  RESET_ACCOUNT_ERRORS,
  UPDATE_LANGUAGE,
} from './AccountType';
import { localeStorageAccessTokenKey } from 'config/config';

let token = localStorage.getItem(localeStorageAccessTokenKey);

export const AccountReducer = (
  state = {
    activatingAccount: false,
    activationSucces: false,
    isLoggingIn: false,
    profile: null,
    roles: [],
    username: null,
    firstName: null,
    lastName: null,
    token: token === 'undefined' || !token ? null : token,
    errorMessages: [],
    recoverySent: false,
    passwordViewModel: {},
    registerViewModel: {},
    passwordRecoveryViewModel: {},
    passwordResetViewModel: {},
    emailConfirmationViewModel: {},
    attemptedLoginWithCookie: false,
    isAdministrator: false,
    languageCode: 'fr-CA',
    gettingProfile: false,
  },
  action,
) => {
  switch (action.type) {
    case LOGIN_PENDING: {
      state = {
        ...state,
        isLoggingIn: true,
      };
      break;
    }
    case LOGIN_FULFILLED: {
      let bearer = `bearer ${action.payload.token}`;
      axios.defaults.headers.common['Authorization'] = bearer;
      axios.defaults.headers.common['Content-Type'] = 'application/json';
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['Pragma'] = 'no-cache';

      localStorage.setItem(localeStorageAccessTokenKey, action.payload.token);

      let profile = state.profile || {};
      profile.id = action.payload.id;
      profile.roles = action.payload.roles;
      profile.person = action.payload.person;
      profile.dealer_Id = action.payload.dealers?.[0]?.dealer_Id || null;
      profile.market_Id = action.payload.market_Id || null;

      let isAdministrator = action.payload.roles.some(userRole => userRole.roleId === RoleEnumValue.Administrator);

      state = {
        ...state,
        attemptedLoginWithCookie: true,
        profile,
        isLoggingIn: false,
        isLoggedIn: true,
        roles: action.payload.roles,
        access_token: action.payload.token,
        username: action.payload.username,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        error: null,
        isAdministrator,
        isDemo: action.payload.isDemo,
      };
      break;
    }
    case LOGIN_REJECTED: {
      localStorage.removeItem(localeStorageAccessTokenKey);

      state = {
        ...state,
        isLoggingIn: false,
        error: action.payload,
        redirectToEmailConfirmation: action.payload.response
          ? action.payload.response.data?.redirectToEmailConfirmation
          : '',
        username: action.payload.response
          ? action.payload.response.data?.redirectToEmailConfirmation
            ? action.payload.response.data.userName
            : ''
          : '',

        attemptedLoginWithCookie: true,
      };
      break;
    }
    case LOGOUT: {
      delete axios.defaults.headers.common['Authorization'];
      delete axios.defaults.headers.common['Content-Type'];
      delete axios.defaults.headers.common['Accept'];
      delete axios.defaults.headers.common['Pragma'];

      localStorage.removeItem(localeStorageAccessTokenKey);

      state = {
        ...state,
        isLoggingIn: false,
        isLoggedIn: false,
        roles: [],
        token_type: null,
        token: null,
        error: null,
      };
      break;
    }

    case GET_PROFILE_PENDING: {
      return { ...state, gettingProfile: true };
    }

    case GET_PROFILE_FULFILLED: {
      return {
        ...state,
        profile: action.payload.profile,
        gettingProfile: false,
      };
    }

    case UPDATE_PROFILE: {
      state = {
        ...state,
        profile: action.payload,
      };
      break;
    }
    case PERSISTING_PROFILE: {
      state = {
        ...state,
        updating: true,
        updated: false,
      };
      break;
    }
    case PERSISTED_PROFILE: {
      const patchedProfile = action.payload ?? {};
      const previousProfile = state.profile ?? {};

      state = {
        ...state,
        updating: false,
        updated: true,
        profile: {
          ...previousProfile,
          ...patchedProfile,
          person: {
            ...previousProfile.person,
            ...patchedProfile.person,
          },
        },
      };
      break;
    }

    case UPDATE_PASSWORD: {
      state = {
        ...state,
        passwordViewModel: action.payload,
      };
      break;
    }
    case PERSISTING_PASSWORD: {
      state = {
        ...state,
        updating: true,
        updated: false,
        errorMessages: [],
      };
      break;
    }
    case PERSISTED_PASSWORD: {
      state = {
        ...state,
        updating: false,
        updated: true,
        passwordViewModel: {},
        errorMessages: [],
      };
      break;
    }
    case PERSIST_PASSWORD_REJECTED: {
      let errorMessages = action.payload;
      state = {
        ...state,
        updating: false,
        updated: false,
        errorMessages: errorMessages,
      };
      break;
    }

    case UPDATE_REGISTERVIEWMODEL: {
      state = {
        ...state,
        registerViewModel: action.payload,
      };
      break;
    }
    case PERSISTING_REGISTERVIEWMODEL: {
      state = {
        ...state,
        updating: true,
        updated: false,
        errorMessages: [],
      };
      break;
    }
    case PERSISTED_REGISTERVIEWMODEL: {
      state = {
        ...state,
        updating: false,
        updated: true,
        registerViewModel: {},
        errorMessages: [],
      };
      break;
    }
    case PERSIST_REGISTERVIEWMODEL_REJECTED: {
      let errorMessages = action.payload;
      state = {
        ...state,
        updating: false,
        updated: false,
        errorMessages,
      };
      break;
    }

    case UPDATE_PASSWORD_RECOVERY: {
      state = {
        ...state,
        passwordRecoveryViewModel: action.payload,
      };
      break;
    }
    case SENDING_EMAIL_CONFIRMATION_EMAIL: {
      state = {
        ...state,
        updating: true,
        updated: false,
        errorMessages: [],
      };
      break;
    }
    case SENT_EMAIL_CONFIRMATION_EMAIL: {
      state = {
        ...state,
        updating: false,
        updated: true,
        errorMessages: [],
      };
      break;
    }
    case SENT_EMAIL_CONFIRMATION_REJECTED: {
      let errorMessages = action.payload;
      state = {
        ...state,
        updating: false,
        updated: false,
        errorMessages,
      };
      break;
    }
    case SENDING_PASSWORD_RECOVERY: {
      state = {
        ...state,
        updating: true,
        updated: false,
        errorMessages: [],
        recoverySent: false,
      };
      break;
    }
    case SENT_PASSWORD_RECOVERY: {
      state = {
        ...state,
        updating: false,
        updated: true,
        errorMessages: [],
        recoverySent: true,
      };
      break;
    }
    case SENT_PASSWORD_RECOVERY_REJECTED: {
      let errorMessages = action.payload;
      state = {
        ...state,
        updating: false,
        updated: false,
        errorMessages,
        recoverySent: false,
      };
      break;
    }

    case UPDATE_PASSWORD_RESET: {
      state = {
        ...state,
        passwordResetViewModel: action.payload,
      };
      break;
    }
    case PERSISTING_EMAIL_CONFIRMATION: {
      state = {
        ...state,
        updating: true,
        updated: false,
        errorMessages: [],
      };
      break;
    }
    case PERSISTED_EMAIL_CONFIRMATION: {
      state = {
        ...state,
        updating: false,
        updated: true,
        errorMessages: [],
        emailConfirmationViewModel: {},
      };
      break;
    }
    case PERSISTED_EMAIL_CONFIRMATION_REJECTED: {
      let errorMessages = action.payload;
      state = {
        ...state,
        updating: false,
        updated: false,
        errorMessages,
      };
      break;
    }
    case PERSISTING_PASSWORDRESET: {
      state = {
        ...state,
        updating: true,
        updated: false,
        errorMessages: [],
        passwordResetSuccess: false,
      };
      break;
    }
    case PERSISTED_PASSWORDRESET: {
      state = {
        ...state,
        updating: false,
        updated: true,
        errorMessages: [],
        passwordResetViewModel: {},
        passwordResetSuccess: true,
      };
      break;
    }
    case PERSISTED_PASSWORDRESET_REJECTED: {
      let errorMessages = action.payload;
      state = {
        ...state,
        updating: false,
        updated: false,
        errorMessages,
        passwordResetSuccess: false,
      };
      break;
    }

    case RESET_ACCOUNT_ERRORS: {
      return { ...state, errorMessages: [], error: {}, passwordResetSuccess: false, recoverySent: false };
    }

    case UPDATE_LANGUAGE: {
      return { ...state, languageCode: action.payload };
    }

    case ACTIVATE_ACCOUNT_PENDING: {
      state = {
        ...state,
        activatingAccount: true,
      };
      break;
    }

    case ACTIVATE_ACCOUNT: {
      state = {
        ...state,
        activatingAccount: false,
        activationSucces: true,
      };
      break;
    }
    case ACTIVATE_ACCOUNT_ERROR: {
      state = {
        ...state,
        activatingAccount: false,
        errorMessages: action.payload,
      };
      break;
    }

    default: {
    }
  }

  return state;
};

export default AccountReducer;
